function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionPointRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14 14 0 100 28 14 14 0 000-28zm0 26a12 12 0 110-24 12 12 0 010 24z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.78 22.09V10.28h4a6.102 6.102 0 012.48.47 3.66 3.66 0 011.65 1.37 3.89 3.89 0 01.58 2.17 3.82 3.82 0 01-.58 2.15 3.73 3.73 0 01-1.65 1.37c-.783.336-1.628.5-2.48.48h-1.5v3.8h-2.5zm3.84-9.64h-1.34v3.65h1.34a2.9 2.9 0 001.66-.43 1.54 1.54 0 00.63-1.38 1.58 1.58 0 00-.63-1.4 2.9 2.9 0 00-1.66-.44z",
    fill: props.color
  }));
}

export default SvgIconPromotionPointRexOutline;